<template>
  <div class="page-question">
    <van-tabs v-model="active" color="#1174b8">
      <van-tab v-for="(item,index) in listData" :key="index" :title="item.name">
        <div class="tab-item">
          <van-collapse v-model="activeNames" :border="false">
            <van-collapse-item v-for="(question , key) in item.pcpfaQs" :key="key" :name="key" :border="false" :is-link="false" :id="question.titel.indexOf('[支付]') == -1 ?'':'zhifu'">
              <div slot="icon" class="list-hd-left-ico">
                <img src="../assets/question_ico01.png" alt="">
              </div>
              <div slot="title" class="list-hd">
                {{question.titel}}
              </div>
              <div slot="right-icon" class="list-hd-right-ico">
                <i class="right-ico"></i>
              </div>
              <div slot="default" class="list-bd">
                <div class="list-ico list-ico-answer">
                  <img src="../assets/question_ico02.png" alt="">
                </div>
                <div class="content-text" v-html="question.text">
                  {{question.text}}
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-tab>
    </van-tabs>
    <!-- footer -->
    <base-footer />
  </div>
</template>

<script>
import api from '@/api'
import BaseFooter from '@/components/BaseFooter'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
export default {
  name: 'PageQuestion',

  components: {
    BaseFooter
  },

  data () {
    return {
      active: 0,
      activeNames: [],
      listData: {}
    }
  },
  activated () {
    this.getQuestion()
  },
  methods: {
    async getQuestion () {
      showLoading()
      const { errCode, errMsg, data } = await api.getQuestion()
      hideLoading()
      if (errCode === 0) {
        this.listData = data.faqCategoryModel
        await this.$nextTick()
        if (this.$route.params.fromIndex === '1') {
          // document.querySelector('#zhifu').scrollTop = document.querySelector('#zhifu').offsetTop
          document.getElementById('zhifu').scrollIntoView({
            behavior: 'smooth', // 默认auto
            block: 'center', // 默认center
            inline: 'nearest' // 默认nearest
          })
        }
      } else {
        showAlert(errMsg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-question{
  .tab-item{
    padding: 30px 50px;
    ::v-deep .van-collapse-item{
      margin-bottom: .2rem;
      border-radius: 4px;
      overflow: hidden;
      background-color: #ffffff;
      padding: .3rem;
      .van-cell{
        padding: 0 0 .3rem;
        font-size: .3rem;
      }
      .list-hd-left-ico{
        width: .4rem;
        margin-top: .1rem;
        img{
          width: 100%;
        }
      }
      .van-cell__title{
        padding: 0 .2rem;
        font-weight: bold;
      }
      .list-hd-right-ico{
        width: .4rem;
        display: flex;
        align-items: center;
        img{
          width: 100%;
        }
        .right-ico{
          width: .4rem;
          height: .4rem;
          background-image: url(../assets/question_ico04.png);
          background-size: 100%;
          background-repeat:  no-repeat;
        }
      }
      .van-collapse-item__title--expanded{
        .list-hd-right-ico{
          .right-ico{
            background-image: url(../assets/question_ico03.png);
          }
        }
      }
      .van-collapse-item__content{
        padding: .3rem 0 0;
        border-top: 1PX solid @main-gray5;
        font-size: .24rem;
        line-height: 1.8;
      }
      .list-bd{
        display: flex;
        .list-ico-answer{
          width: .4rem;
          img{
            width: 100%;
          }
        }
        .content-text{
          color: @main-gray4;
          .title{
            color: @main-gray3
          }
          flex: 1;
          padding-left: .2rem;
        }
      }
    }
  }
}
</style>
